import {
  DESKTOP_TOP_NAV_V3_HEIGHT,
  MOBILE_NAV_V3_HEIGHT
} from '@dtx-company/true-common/src/constants/layout'
import { Dialog, Drawer, useMediaQuery } from '@mui/material'
import { ModalTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { PlanUpgradeMobileHeader } from './components/PlanUpgradeMobileHeader'
import { PlansUpgradeContainer } from './components/PlansUpgradeContainer'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Stack } from '@mui/system'
import { theme } from '@dtx-company/design-system/src'
import { useModal } from '@dtx-company/inter-app/src/redux/slices/utils'
import { useV3NavigationTopOffset } from '../../../side/v3/hooks'
import OutsideClickHandler from 'react-outside-click-handler'
import React from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'

export const PlansUpgradeDialog: React.FC = () => {
  const { modalOpen, setClose } = useModal(ModalTypes.NAV_PLANS_UPGRADE_DIALOG)
  const { topNavTopOffset } = useV3NavigationTopOffset()
  const onClose = (): void => {
    events.Platform_PlansUpgradeDialog_Dismissed_Dialog()
    setClose()
  }
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down('md'))
  if (isTabletOrSmaller) {
    return (
      <Dialog
        open={modalOpen}
        onClose={setClose}
        fullScreen
        sx={{ zIndex: 'modal', maxHeight: 'unset' }}
        data-testid="plans-upgrade-modal"
      >
        <Stack direction="column">
          <PlanUpgradeMobileHeader onClose={onClose} />
          <Spacer mb={`${MOBILE_NAV_V3_HEIGHT}px`} />
          <PlansUpgradeContainer />
        </Stack>
      </Dialog>
    )
  } else {
    return (
      <OutsideClickHandler
        onOutsideClick={() => {
          if (modalOpen) {
            onClose()
          }
        }}
      >
        <Drawer
          anchor="top"
          open={modalOpen}
          sx={{ zIndex: 1190 }}
          data-testid="plans-upgrade-drawer"
          variant="temporary"
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              top: `${DESKTOP_TOP_NAV_V3_HEIGHT + topNavTopOffset}px`
            }
          }}
          hideBackdrop
        >
          <PlansUpgradeContainer />
        </Drawer>
      </OutsideClickHandler>
    )
  }
}
